import React from "react";

export function Subtitle(props) {
    return <h6 className="drawer__subtitle">{props.children}</h6>;
}